import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subject, takeUntil, tap } from 'rxjs';
import { EventsService } from '../services/events.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confetti',
  templateUrl: './confetti.component.html',
  styleUrl: './confetti.component.scss'
})
export class ConfettiComponent implements OnInit, OnDestroy {

  @ViewChild('confetti') private confettiRef: TemplateRef<never>;
  componentDestroyed: Subject<boolean>;

  constructor(private eventsService: EventsService, private modalService: NgbModal) {
    this.componentDestroyed = new Subject<boolean>();
  }

  ngOnInit(): void {
    this.eventsService.confettiExplosion.pipe(
      tap(() => {
        this.createConfetti();
      }),
      takeUntil(this.componentDestroyed)
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(true);
    this.componentDestroyed.complete();
  }

  createConfetti() {
    const modal = this.modalService.open(this.confettiRef, {
      keyboard: false,
      backdrop: 'static',
      centered: true,
      fullscreen: true,
      backdropClass: 'modal-backdrop-confetti',
      modalDialogClass: 'modal-confetti'
    });

    // Generate confetti
    const confettiWrapper = document.querySelector('.confetti-wrapper');
    for (let i = 0; i < 500; i++) {
      const left = i % 2 === 0;
      const confetti = document.createElement('div');
      confetti.classList.add('confetti-piece');
      if (left) {
        confetti.classList.add('confetti-left');
        confetti.style.setProperty('--startX', `${Math.random() * 50}vw`);
      } else {
        confetti.classList.add('confetti-right');
        confetti.style.setProperty('--startX', `${Math.random() * 50 + 50}vw`);
      }
      confetti.style.setProperty('--startY', `${Math.random() * 20}vh`);
      confetti.style.setProperty('--fall-duration', `${Math.random() * 6 + 2}s`);
      confetti.style.setProperty('--start-delay', `${Math.random()}s`);
      confetti.style.setProperty('--confetti-colour', this.pickColour());
      
      confettiWrapper.appendChild(confetti);
    }

    setTimeout(() => {
      modal.close();
    }, 5000);
  }

  pickColour(): string {
    const colours = ['#847ab6', '#e31315', '#1e8dce', '#ef86b4', '#fdcf4f', '#009a3c'];
    return colours[Math.floor(Math.random() * 6)];
  }
}
